import { useEffect, useRef, useState } from "react";
import { useQuery, useMutation } from "@apollo/client";
import {
  Avatar,
  Box,
  Button,
  Chip,
  Divider,
  Fade,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Modal,
  styled,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  Autocomplete,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { MultiInputDateRangeField } from "@mui/x-date-pickers-pro/MultiInputDateRangeField";
import dayjs from "dayjs";
import { ExpandMore } from "@mui/icons-material";
import Status from "../../Images/svgs/status.svg";
import Calender from "../../Images/svgs/calender.svg";
import { getIssueById, updateIssueMutation } from "../../gql/mutations/kanban";
import CalenderImg from "../../Images/svgs/calender-1.svg";
import Tags from "../../Images/svgs/Tags.svg";
import Flag from "../../Images/svgs/flag.svg";
import userComment from "../../Images/svgs/user-coment.svg";
import commentIcon from "../../Images/svgs/comment-icon.svg";
import assigne from "../../Images/svgs/assignee.svg";

const BoxWrapper = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: theme.palette.background.default,
  border: `2px solid ${theme.palette.divider}`,
  borderRadius: "6px",
  padding: "25px 25px",
  "@media screen and (max-width:600px)": {
    width: "90%",
    padding: "10px 15px",
  },
  "& .LoaderAndErrorWrapper": {
    height: "400px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  "& .saveBtn": {
    marginTop: "40px",
    "@media screen and (max-width:600px)": {
      marginTop: "20px",
    },
    "& button": {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      padding: "12px 0px",
      width: "180px",

      fontWeight: 600,
      fontSize: "14px",
    },
    "& .addCommentButton": {
      backgroundColor: "transparent",
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: "8px",

      marginLeft: "10px",
      gap: "10px",
      "& img": {
        width: "22.5px",
      },
      color: theme.palette.text.primary,
      "&:hover": { backgroundColor: theme.palette.primary.main },
    },
  },
  "& .BodyContentWrapper": {
    "& .DetailListWrapper": {
      "& p": {
        fontSize: "14px",
        fontWeight: 700,
        marginBottom: "8px",
        color: theme.palette.text.primary,
        "& span": {
          fontSize: "14px",
          fontWeight: 400,
        },
      },
    },
    "& .CommentListWrapper": {
      marginTop: "10px",
      "& h3": {
        fontSize: "14px",
        fontWeight: 700,
        marginBottom: "8px",
        color: theme.palette.text.primary,
      },
      "& .comment": {
        fontSize: "13px",
        marginBottom: "6px",
        color: theme.palette.text.secondary,
        background: theme.palette.background.paper,
        padding: "6px 10px",
        borderRadius: "4px",
      },
    },
    "& .TagListWrapper": {
      "& h3": {
        fontSize: "14px",
        fontWeight: 700,
        marginBottom: "8px",
        color: theme.palette.text.primary,
      },
      "& .TagInnerListWrapper": {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "6px",
        flexWrap: "wrap",
        "& .TagWrapper": {
          "& .TagEditForm": {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "6px",
            "& > .MuiFormControl-root": {
              "& .MuiInputBase-root": {
                paddingRight: "2px",
                borderRadius: "50px",
                "& input": {
                  padding: "4px 6px 5px 10px",
                  lineHeight: 1,
                  fontSize: "12px",
                  width: "80px",
                },
                "& .MuiInputAdornment-root": {
                  "& button": {
                    height: "auto",
                    lineHeight: 1,
                    backgroundColor: theme.palette.primary.main,
                    color: "#ffffff",
                    fontSize: "12px",
                    borderRadius: "50px",
                  },
                },
              },
            },
          },
        },
      },
    },
    "& .TagAddWrapper": {
      marginTop: "15px",
      "& > .MuiFormControl-root": {
        marginBottom: "10px",
        "& label": {
          marginBottom: "0",
          top: "50%",
          transform: "translate(14px, -50%)",
          "&.MuiInputLabel-shrink": {
            top: "0",
            transform: "translate(14px, -9px) scale(0.75)",
          },
        },
        "& .MuiInputBase-root": {
          paddingRight: "3px",
          "& input": {
            padding: "10px 6px 10px 10px",
          },
          "& .MuiInputAdornment-root": {
            "& button": {
              padding: "10px 6px 10px 10px",
              height: "auto",
              lineHeight: 1,
              backgroundColor: theme.palette.primary.main,
              color: "#ffffff",
              fontSize: "12px",
              borderRadius: "5px",
            },
          },
        },
      },
    },
    "& .BtnWrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "12px",
      marginTop: "15px",
      "& button": {
        textTransform: "none",
        backgroundColor: theme.palette.primary.main,
        color: "#ffffff",
        borderRadius: "5px",
        boxShadow: "none",
        padding: "7px 22px",
        whiteSpace: "nowrap",
        width: "100%",
        "&:focus": {
          outline: "none",
        },
        "&:hover": {
          backgroundColor: theme.palette.primary.dark,
        },
        "&.OutlineBtn": {
          color: theme.palette.primary.main,
          backgroundColor: "transparent",
          border: `2px solid ${theme.palette.primary.main}`,
          padding: "6px 22px",
          "&:hover": {
            backgroundColor: theme.palette.primary.dark,
            color: "#fff",
          },
        },
      },
    },
  },

  "& .top_content": {
    display: "flex",
    justifyContent: "space-between",
    "@media screen and (max-width: 600px)": {
      alignItems: "center",
    },
    "& h2": {
      fontWeight: 700,
      fontSize: "32px",
      lineHeight: "40px",
      color: theme.palette.text.primary,
    },
    "& .closeBtn": {
      width: "24px",
      height: "24px",
      minWidth: "24px",
      maxWidth: "24px",
      // borderRadius: "10px",
      // border: `1px solid ${theme.palette.primary.main}`,
      backgroundColor: "transparent",
      padding: "10px !important",

      "&:focus": {
        border: "none",
        outline: "none",
      },
      "&:hover": {
        backgroundColor: "transparent",
        color: "#fff",
        "& svg": {
          fill: theme.palette.primary.main,
        },
      },
    },
  },
  "& .left_panel_field": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "90px",
    "@media screen and (max-width: 600px)": {
      gap: "10px",
      flexDirection: "column",
      justifyContent: "start",
      alignItems: "start",
    },
    "& .left_icon_group": {
      display: "flex",
      // justifyContent: "space-between",
      alignItems: "center",
      gap: "10px",
      minWidth: "85px",
      "& h3": {
        fontWeight: 700,
        fontSize: "16px",
        lineHeight: "100%",
        color: theme.palette.text.primary,
      },
      "& img": {
        filter: theme.palette.mode === "dark" ? "brightness(0) invert(1)" : "none",
      },
    },
    "& .left_panel_right_box": {
      width: "70%",
      "@media screen and (max-width: 600px)": {
        width: "100%",
      },
      "& .TagListWrapper": {
        border: `1px solid ${theme.palette.mode === "dark" ? "#465670" : "#DFE5EF"}`,
        borderRadius: "8px",
        padding: "4.5px 12px 4.5px 12px",
        maxHeight: "100px",
        overflowY: "auto",
        display: "flex",
        flexWrap: "wrap",
        gap: "6px",
        "@media screen and (max-width: 600px)": {
          maxHeight: "80px",
        },
      },
      "& .AssignWrapper": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& .MuiAvatar-root": {
          border: "1px solid #ffffff",
          fontSize: "10px",
          width: "28px",
          height: "28px",
          marginLeft: "-10px",
          "&:first-of-type": {
            marginLeft: "0px",
          },
          "&.MoreAvatar": {
            backgroundColor: theme.palette.primary.main,
          },
        },
      },
      "& .calenderMonth": {
        width: "16px",
      },
      "& .MuiAutocomplete-root": {
        "& .MuiFormControl-root": {
          "& label": {
            marginBottom: "0",
            top: "50%",
            transform: "translate(14px, -50%)",
            "&.MuiInputLabel-shrink": {
              top: "0",
              transform: "translate(14px, -9px) scale(0.75)",
            },
          },
          "& .MuiInputBase-root": {
            height: "40px",
          },
        },
      },
      "& .select_priority": {
        width: "190px",
        "@media screen and (max-width: 600px)": {
          width: "100%",
        },
        "& label": {
          marginBottom: "0",
          top: "50%",
          transform: "translate(14px, -50%)",
          "&.MuiInputLabel-shrink": {
            top: "0",
            transform: "translate(14px, -9px) scale(0.75)",
          },
        },
        "& .MuiSelect-select": {
          padding: "10px 12px 10px 12px",
        },
      },
      "& .datePickerRange ": {
        // position: "relative",
        // "& .calenderImage": {
        //   position: "absolute",
        //   top: "50%",
        //   left: "115px",
        //   transform: "translateY(-50%)",
        // },
        "@media screen and (max-width: 600px)": {
          "& .MuiFormControl-root:first-of-type": {
            "& input": {
              paddingLeft: "15px",
            },
          },
        },

        "& .MuiInputBase-root": {
          display: "flex",
          flexDirection: "row-reverse",
          height: "40px",

          "& input": {
            paddingLeft: "0",
            paddingRight: "0",
            fontWeight: 500,
            fontSize: "14px",
            lineHeight: "100%",
            color: theme.palette.mode === "dark" ? "#fff" : "#808080",
            "@media screen and (max-width: 600px)": {
              fontSize: "13px",

              paddingLeft: "5px",
              paddingRight: "5px",
            },
          },
        },
        "& .MuiFormControl-root": {
          minWidth: "154px",
          width: "154px",
          // border: "1px solid #E3E3E3",
          borderRadius: "6px",
          "@media screen and (max-width: 600px)": {
            width: "46%",
            minWidth: "47%",
          },
          "& label": {
            marginBottom: "0",
            top: "50%",
            transform: "translate(14px, -50%)",
            "&.MuiInputLabel-shrink": {
              top: "0",
              transform: "translate(14px, -9px) scale(0.75)",
            },
          },
        },
        "& .MuiMultiInputDateRangeField-separator": {
          display: "none",
        },
      },
      "& .addAssigneeBox": {
        marginLeft: "-8px",
        "& button": {
          backgroundColor: "transparent",
          padding: "0",
          display: "block",
          width: "28px",

          border: "1px solid #fff",
          maxWidth: "28px",
          minWidth: "28px",
          borderRadius: "50%",
          "&:focus": {
            outline: "none",
            border: "none",
          },
          "& svg": {
            backgroundColor: theme.palette.primary.main,
          },
        },
      },
    },
  },
  "& .right_panel_field_add_comment": {
    "& h2": {
      fontWeight: 700,
      fontSize: "18px",
      lineHeight: "100%",
      color: theme.palette.text.primary,
    },
    "& .commentBox": {
      border: `1px solid ${theme.palette.mode === "dark" ? "#465670" : "#DFE5EF"}`,
      backgroundColor: theme.palette.mode === "dark" ? "#171c23" : "#F9F9F9",
      borderRadius: "6px",
      padding: "10px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      minHeight: "312px",
      "& .commentButton": {
        backgroundColor: "transparent",
        "&:focus": {
          border: "none",
          outline: "none",
        },
      },
      "& .commentInputBox": {
        "& input": {
          color: "#808080",
        },
        "& .MuiInputBase-root": {
          paddingRight: "0 ",
        },
      },
      "& .innerCommentBox": {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        gap: "15px",
        overflowY: "auto",
        marginBottom: "20px",
        maxHeight: "240px",
        "@media screen and (max-width: 600px)": {
          paddingBottom: "20px",
          paddingRight: "10px",
        },
        "&::-webkit-scrollbar-track": {
          WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.3)",
          borderRadius: "10px",
          backgroundColor: "#F5F5F5",
        },
        "&::-webkit-scrollbar": { width: "5px", backgroundColor: "transparent" },
        "&::-webkit-scrollbar-thumb": {
          borderRadius: "10px",
          WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,.3)",
          backgroundColor: theme.palette.primary.main,
        },
        "& .commentListBox": {
          display: "flex",
          alignItems: "start",
          gap: "6px",

          "& .commentList": {
            backgroundColor: theme.palette.primary.light,
            borderRadius: "8px",
            padding: "6px 6px 6px 10px",
            width: "90%",
            border: "1px solid #E3E3E3",
            "@media screen and (max-width: 600px)": {
              width: "88%",
            },
            "& p": {
              color: theme.palette.mode === "dark" ? "#fff" : "#808080",
              fontWeight: 500,
              fontSize: "12px",
              lineHeight: "20px",
              wordWrap: "break-word",
            },
          },
        },
      },
    },
  },
}));

function IssuePopup({ open, issueId, setWidthLoader, handleClose, refetchKanban, teamMembers = [], onAssigneesChange }) {
  const theme = useTheme();
  const { data, refetch, loading } = useQuery(getIssueById, {
    variables: { issueId },
    fetchPolicy: "no-cache",
    skip: !open || !issueId,
  });
  const issue = data?.GetIssueById;
  const [comments, setComments] = useState(issue?.comments || []);
  const [comment, setComment] = useState("");
  const [showMobileComment, setShowMobileComment] = useState(false);
  const [showMobileTaskPanel, setShowMobileTaskPanel] = useState(true);
  const [selectedPriority, setSelectedPriority] = useState("");
  const [status, setStatus] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [showTags, setShowTags] = useState(issue?.tags || []);
  const [deletedTags, setDeletedTags] = useState([]);
  const [UPDATE_ISSUE] = useMutation(updateIssueMutation);
  const handleCloseAddComment = () => {
    setShowMobileComment(false);
    setShowMobileTaskPanel(true);
  };
  const [assignees, setAssignees] = useState([]);
  const [filteredTeamMembers, setFilteredTeamMembers] = useState(teamMembers || []);
  // useEffect(() => {
  //   setFilteredTeamMembers(teamMembers);
  // }, [teamMembers]);
  useEffect(() => {
    if (issue?.assignees) {
      setAssignees(issue.assignees);
    }
  }, [issue]);

  useEffect(() => {
    const newFiltered = teamMembers.filter(member => !assignees.some(assignee => assignee._id === member._id));
    // console.log("Filtered Team Members:", newFiltered);
    setFilteredTeamMembers(newFiltered);
  }, [assignees, teamMembers]);

  const handleUpdatedIssue = async () => {
    const [startDate, endDate] = dateRange;
    const newTags = showTags.filter(tag => tag.isNew).map(tag => tag.value);
    const newComments = comments.filter(comm => comm.isNew).map(comm => comm.value);
    // console.log("Assignees before mapping:", assignees);
    const assigneeIds = assignees.map(a => a._id).filter(Boolean);
    // console.log("Assignee IDs to be sent:", assigneeIds);
    try {
      const response = await UPDATE_ISSUE({
        variables: {
          data: {
            issueId: issue._id,
            assignees: assigneeIds,
            status,
            priority: selectedPriority,
            dateRange: {
              startDate,
              endDate,
            },
            deletedTags,
            newTags,
            newComments,
          },
        },
      });

      if (response?.data?.UpdateIssue?.success) {
        if (refetchKanban) await refetchKanban();
        handleClose();
        await refetch();
      }

      return response?.data?.UpdateIssueAll ?? null;
    } catch (err) {
      console.error("Error updating issue:", err);
      return null;
    }
  };

  const handleSave = async () => {
    setWidthLoader(true);
    const updated = await handleUpdatedIssue();
    if (updated?.success) {
      if (onAssigneesChange) {
        onAssigneesChange(assignees); // Send selected assignees back to parent
        const selectedIds = assignees.map(assignee => assignee._id);
        // console.log("Selected Assignees IDs:", selectedIds);
      }
      handleClose();
    }
    setWidthLoader(false);
  };

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const allDivs = document.querySelectorAll("div");
      allDivs.forEach(div => {
        if (div.textContent?.includes("MUI X Missing license key") && div.style?.zIndex === "100000") {
          div.style.display = "none";
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
    };
  }, []);

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const bottomRef = useRef(null);

  useEffect(() => {
    if (showMobileComment && bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [showMobileComment, issue?.comments]);

  useEffect(() => {
    if (issue) {
      setStatus(issue.status?.toLowerCase().replace(/\s/g, "_") || "");
      setSelectedPriority(issue?.priority || "");
      const startDate = issue.dateRange?.startDate ? dayjs(issue.dateRange.startDate) : null;
      const endDate = issue.dateRange?.endDate ? dayjs(issue.dateRange.endDate) : null;
      setDateRange([startDate, endDate]);
      setShowTags(issue?.tags || []);
      setComments(issue?.comments || []);
    }
  }, [issue, loading]);

  if (loading) {
    return (
      <Modal open={open} onClose={handleClose} closeAfterTransition>
        <Fade in={open}>
          <BoxWrapper sx={{ width: "90%", maxWidth: 1004 }}>
            <Box className="LoaderAndErrorWrapper">
              <Typography>Loading...</Typography>
            </Box>
          </BoxWrapper>
        </Fade>
      </Modal>
    );
  }
  // const assigneeObjects = filteredTeamMembers.filter(member => assignees.includes(member._id)); // Get full objects of selected assignees
  // console.log("assigneeObjects:", assigneeObjects);
  // console.log("filteredTeamMembers:", filteredTeamMembers);
  // console.log("assignees:", assignees);

  return (
    <Modal open={open} onClose={handleClose} closeAfterTransition>
      <Fade in={open}>
        <BoxWrapper sx={{ width: "90%", maxWidth: 1004 }}>
          <Box className="top_content">
            <Typography component="h2">Task 1</Typography>
            <Button className="closeBtn" onClick={handleClose}>
              <CancelIcon />
            </Button>
          </Box>
          <Divider sx={{ my: "12px", color: "#CECECE" }} />
          <Grid container spacing={4}>
            {!isMobile || showMobileTaskPanel ? (
              <Grid item xs={12} md={7}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                  <Box className="left_panel_field">
                    <Box className="left_icon_group">
                      <Typography component="img" src={Status} alt />
                      <Typography component="h3">Status</Typography>
                    </Box>
                    <Box className="left_panel_right_box">
                      <TextField
                        className="select_status"
                        id="outlined-select-status"
                        select
                        label="Select Status"
                        value={status}
                        onChange={e => setStatus(e.target.value)}
                        fullWidth
                      >
                        <MenuItem value="open">Open</MenuItem>
                        <MenuItem value="closed">Closed</MenuItem>
                        <MenuItem value="in_progress">In Progress</MenuItem>
                      </TextField>
                    </Box>
                  </Box>
                  <Box className="left_panel_field">
                    <Box className="left_icon_group">
                      <Typography component="img" src={CalenderImg} alt />
                      <Typography component="h3">Dates</Typography>
                    </Box>
                    <Box className="left_panel_right_box">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box className="datePickerRange">
                          <DateRangePicker
                            className="datePickerRange"
                            value={dateRange}
                            onChange={newValue => setDateRange(newValue)}
                            slots={{ field: MultiInputDateRangeField }}
                            slotProps={{
                              textField: ({ position }) => {
                                const adornment = (
                                  <InputAdornment position="start">
                                    <Typography component="img" src={Calender} alt="calendar" />
                                  </InputAdornment>
                                );

                                return {
                                  placeholder: position === "start" ? "Start" : "End",
                                  InputProps: {
                                    startAdornment: adornment,
                                  },
                                  sx: {
                                    minWidth: 150,
                                  },
                                };
                              },
                            }}
                          />
                        </Box>
                      </LocalizationProvider>
                    </Box>
                  </Box>

                  <Box className="left_panel_field">
                    <Box className="left_icon_group">
                      <Typography component="img" src={Tags} alt />
                      <Typography component="h3">Tags</Typography>
                    </Box>
                    <Box className="left_panel_right_box">
                      <Box className="TagListWrapper">
                        {showTags.map((tag, index) => (
                          <Chip
                            key={tag.id}
                            label={tag.value}
                            onDelete={async () => {
                              setShowTags(prev => prev.filter(item => item.id !== tag.id));
                              setDeletedTags(prev => [...prev, tag]);
                            }}
                            sx={{ maxHeight: 24 }}
                          />
                        ))}

                        <TextField
                          placeholder="Add Tags"
                          variant="standard"
                          onKeyDown={async e => {
                            if (e.key === "Enter" && e.target.value?.trim()) {
                              const inputValue = e.target.value.trim();
                              const isDuplicate = showTags.some(tag => tag.value.toLowerCase() === inputValue.toLowerCase());
                              if (isDuplicate) {
                                e.target.value = "";
                                return;
                              }
                              const newTag = {
                                id: Date.now().toString(),
                                value: inputValue,
                                isNew: true,
                              };
                              setShowTags(prev => [...prev, newTag]);
                              e.target.value = "";
                            }
                          }}
                          InputProps={{ disableUnderline: true }}
                          sx={{ minWidth: 120, flex: 1, gap: 2 }}
                        />
                      </Box>
                    </Box>
                  </Box>

                  <Box className="left_panel_field">
                    <Box className="left_icon_group">
                      <Typography component="img" src={Flag} alt />
                      <Typography component="h3">Priority</Typography>
                    </Box>
                    <Box className="left_panel_right_box">
                      <TextField
                        className="select_priority"
                        id="outlined-select-priority"
                        select
                        label="Select Priority"
                        value={selectedPriority}
                        onChange={e => setSelectedPriority(e.target.value)}
                      >
                        <MenuItem value="High">High</MenuItem>
                        <MenuItem value="Medium">Medium</MenuItem>
                        <MenuItem value="Low">Low</MenuItem>
                      </TextField>
                    </Box>
                  </Box>
                  <Box className="left_panel_field">
                    <Box className="left_icon_group">
                      <Typography component="img" src={assigne} alt />
                      <Typography component="h3">Assign</Typography>
                    </Box>
                    <Box className="left_panel_right_box">
                      <Autocomplete
                        multiple
                        // options={teamMembers}
                        options={filteredTeamMembers}
                        getOptionLabel={option => option.name} // assuming each member has a "name"
                        value={assignees}
                        onChange={(event, newValue) => setAssignees(newValue)}
                        isOptionEqualToValue={(option, value) => option._id === value._id}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              label={option.name}
                              {...getTagProps({ index })}
                              key={option.id}
                              sx={{
                                maxHeight: "28px",
                                maxWidth: "180px", // limit max width to avoid too long
                                whiteSpace: "normal", // allow wrapping text if name is long
                                overflowWrap: "break-word", // break long words if needed
                                wordBreak: "break-word",
                              }}
                            />
                          ))
                        }
                        renderInput={params => <TextField {...params} label="Assignees" placeholder="Select assignees" />}
                        fullWidth
                      />
                    </Box>
                  </Box>
                </Box>
                <Box className="saveBtn" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Button onClick={handleSave}>Save</Button>
                  <IconButton
                    sx={{ display: { xs: "inline-flex", md: "none" } }}
                    onClick={() => {
                      setShowMobileComment(true);
                      setShowMobileTaskPanel(false);
                    }}
                    className="addCommentButton"
                  >
                    <Typography component="img" src={commentIcon} alt="Toggle Comment" />
                    Add Comment
                  </IconButton>
                </Box>
              </Grid>
            ) : null}

            <Grid item xs={12} md={5} sx={{ display: { xs: "none", md: "block" } }}>
              <Box className="right_panel_field_add_comment">
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                  <Typography component="h2" sx={{ fontWeight: 600 }}>
                    Add Comment
                  </Typography>
                </Box>

                <Box className="commentBox">
                  <Box className="innerCommentBox">
                    {comments.length > 0 ? (
                      comments.map(comm => (
                        <Box className="commentListBox" key={comm.id}>
                          <Box sx={{ width: "24px" }}>
                            <Avatar sx={{ width: "24px", height: "24px" }} src={userComment} alt="" />
                          </Box>
                          <Box className="commentList">
                            <Typography component="p" sx={{ fontSize: "14px", color: "#333" }}>
                              {comm.value}
                            </Typography>
                          </Box>
                        </Box>
                      ))
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        No comments yet.
                      </Typography>
                    )}
                    <Box ref={bottomRef} />
                  </Box>

                  <TextField
                    placeholder="Comment"
                    value={comment}
                    onChange={e => setComment(e.target.value)}
                    fullWidth
                    variant="outlined"
                    size="small"
                    className="commentInputBox"
                    InputProps={{
                      sx: {
                        backgroundColor: "#fff",
                        borderRadius: "8px",
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <Button
                            sx={{ minWidth: 0, padding: 1 }}
                            onClick={async () => {
                              if (comment.trim()) {
                                setComments(prev => [...prev, { id: Date.now().toString(), value: comment, isNew: true }]);
                                setComment("");
                              }
                            }}
                            className="commentButton"
                          >
                            <Typography component="img" src={commentIcon} alt="" />
                          </Button>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              </Box>
            </Grid>
            {showMobileComment && (
              <Grid item xs={12} md={5} sx={{ display: { xs: "block", md: "none" } }}>
                <Box className="right_panel_field_add_comment">
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    <Typography component="h2" sx={{ fontWeight: 600 }}>
                      Add Comment
                    </Typography>
                    <Button className="closeBtn" onClick={handleCloseAddComment}>
                      Close
                    </Button>
                  </Box>
                  <Box className="commentBox">
                    <Box className="innerCommentBox">
                      {issue?.comments?.length > 0 ? (
                        issue.comments.map(comm => (
                          <Box className="commentListBox" key={comm.id}>
                            <Box sx={{ width: "24px" }}>
                              <Avatar sx={{ width: "24px", height: "24px" }} src={userComment} alt="" />
                            </Box>
                            <Box className="commentList">
                              <Typography component="p" sx={{ fontSize: "14px", color: "#333" }}>
                                {comm.value}
                              </Typography>
                            </Box>
                          </Box>
                        ))
                      ) : (
                        <Typography variant="body2" color="text.secondary">
                          No comments yet.
                        </Typography>
                      )}
                      <Box ref={bottomRef} />
                    </Box>

                    <TextField
                      placeholder="Comment"
                      value={comment}
                      onChange={e => setComment(e.target.value)}
                      fullWidth
                      variant="outlined"
                      size="small"
                      className="commentInputBox"
                      InputProps={{
                        sx: {
                          backgroundColor: "#fff",
                          borderRadius: "8px",
                        },
                        endAdornment: (
                          <InputAdornment position="end">
                            <Button
                              sx={{ minWidth: 0, padding: 1 }}
                              onClick={async () => {
                                if (comment.trim()) {
                                  setComments(prev => [...prev, { id: Date.now().toString(), value: comment, isNew: true }]);
                                  setComment("");
                                }
                              }}
                              className="commentButton"
                            >
                              <Typography component="img" src={commentIcon} alt="" />
                            </Button>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                </Box>
              </Grid>
            )}
          </Grid>
        </BoxWrapper>
      </Fade>
    </Modal>
  );
}

export default IssuePopup;
